import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../core/config/core.httpclient-utils';

import * as _ from 'lodash';

@Component({
    selector: 'gf-link-preview',
    template: require('./gf-link-preview.component.html')
})
export class LinkPreviewComponent implements OnInit {

    @Input() url: string;

    protected loading: boolean = true;

    protected title: string;
    private error: string;
    protected description: string;
    protected thumbnail: string;

    /** Full commit details, when the URL is a git commit (see GForgeUrlPreviewService). */
    protected commit: any = null;

    constructor(private httpClient: HttpClient) {
    }

    getUrlPreview(url) {
        return doGetPromise(
            this.httpClient,
            '/site/urlrendering',
            { 'url': url }
        );
    }

    ngOnInit() {
        this.getUrlPreview(this.url)
            .then((response) => {
                this.title = _.get(response, 'title', '');
                if (this.title.length == 0) {
                    this.title = 'Web Link';
                }
                this.error = _.get(response, 'error', false);

                if (this.error) {
                    console.log(`URL fetch failed: ${ this.error }`, this.url);
                }

                var tags = _.get(
                    response, 'metatags', {}
                );
                this.description = _.get(tags, 'description', false);
                this.thumbnail = _.get(tags, 'image', false);
                this.commit = response?.commit ?? null;
            }).finally(() => {
                this.loading = false;
            });
    };
}